module.exports = __webpack_public_path__ + "static/media/Charing Cross c. 1973.fb8d06fc.jpg";